import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '韵动巴渝·2026重庆体育影像比赛';
const baseUrl = '20260630TYSY';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeDetail',
      name: `${baseUrl}-homeDetail`,
      component: () => import('./pages/HomeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'review',
      name: `${baseUrl}-review`,
      component: () => import('./pages/Review.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'reviewDetail',
      name: `${baseUrl}-reviewDetail`,
      component: () => import('./pages/ReviewDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
